import random from 'lodash/random';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { XeroBankAccountCard } from './XeroBankAccountCard';

export const Loading = memo(() => {
    return (
        <XeroBankAccountCard
            disabled={false}
            id='skeleton'
            bankAccountNumber={<Skeleton width={random(60, 90)} />}
            currencyCode={<Skeleton width={40} />}
            name={<Skeleton width={`${random(50, 80)}%`} />}
            sortCode={<Skeleton width={50} />}
        />
    );
});

Loading.displayName = 'Loading';
